import axios from 'axios'
import useSWR from 'swr'

const useGetWPAxios = (callMethod) => {
	const fetcher = async (url) => await axios.get(url).then((res) => res.data)
	const { data, error } = useSWR(process.env.REACT_APP_WP_API_URL + callMethod, fetcher)
    return { data, error }
};

export default useGetWPAxios